import React from "react";

// ----------------------
// Dynamic Data for Senior Secondary
// ----------------------
const seniorGroupA = [
  { sr: 1, code: 301, subject: "Hindi" },
  { sr: 2, code: 302, subject: "English" },
  { sr: 3, code: 303, subject: "Urdu" },
  { sr: 4, code: 304, subject: "Sanskrit" },
  { sr: 5, code: 305, subject: "Bengali" },
  { sr: 6, code: 306, subject: "Odia" },
  { sr: 7, code: 307, subject: "Punjabi" },
  { sr: 8, code: 308, subject: "Kannada" },
  { sr: 9, code: 309, subject: "Malayalam" },
  { sr: 10, code: 310, subject: "Tamil" },
  { sr: 11, code: 311, subject: "Telugu" },
  { sr: 12, code: 312, subject: "Gujarati" },
  { sr: 13, code: 313, subject: "Marathi" },
];

const seniorGroupB = [
  { sr: 1, code: 401, subject: "Mathematics" },
  { sr: 2, code: 402, subject: "Family & Community Studies*" },
  { sr: 3, code: 403, subject: "Psychology*" },
  { sr: 4, code: 404, subject: "Geography*" },
  { sr: 5, code: 405, subject: "Economics" },
  { sr: 6, code: 406, subject: "Business Studies" },
  { sr: 7, code: 410, subject: "Physics*" },
  { sr: 8, code: 412, subject: "History" },
  {
    sr: 9,
    code: 413,
    subject: "Environmental Science & Sustainable Development*",
  },
  { sr: 10, code: 415, subject: "Chemistry*" },
  { sr: 11, code: 416, subject: "Political Science" },
  { sr: 12, code: 418, subject: "Biology*" },
  { sr: 13, code: 419, subject: "Accountancy" },
  { sr: 14, code: 420, subject: "Law, Justice & Governance" },
  { sr: 15, code: 421, subject: "Digital Literacy & Computer Science*" },
  { sr: 16, code: 422, subject: "Sociology" },
  { sr: 17, code: 423, subject: "Tourism" },
  { sr: 18, code: 424, subject: "Physical Education and Yoga*" },
];

export default function SeniorSecondaryProgramme() {
  const bannerStyle = {
    width: "100%",
    height: "400px", // adjust the height as needed
    backgroundImage: 'url("./images/class12.jpg")', // replace with your image URL
    backgroundSize: "contain",
    backgroundPosition: "center",
  };

  const container = {
    maxWidth: "900px",
    margin: "auto",
    padding: "20px",
    lineHeight: "1.8",
    fontFamily: "Arial, sans-serif",
  };

  const heading = { color: "#1a237e" };

  const tableWrapper = {
    overflowX: "auto",
    margin: "20px 0",
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "16px",
    background: "white",
    borderRadius: "8px",
    minWidth: "400px",
  };

  const theadStyle = {
    backgroundColor: "#3949ab",
    color: "#fff",
    textAlign: "left",
  };

  const thtd = {
    padding: "12px 15px",
    borderBottom: "1px solid #ddd",
  };

  return (
    <>
      <br />
      <br />
      <br />

      <div style={bannerStyle}></div>
      <div style={container}>
        <h2 style={heading}>Senior Secondary Programme</h2>

        <p>
          Senior Secondary Programme is equivalent to XIIth standard. Those who
          have successfully passed Secondary are eligible to take admission to
          Sr. Secondary Programme of BOSSE. All applicants need to submit a
          self-attested copy of their Secondary Certificate. There is no
          restriction on choice of subjects and combinations, except that
          minimum one language has to be taken.
        </p>

        <p>
          Learners can choose their subjects from the BOSSE List of Subjects as
          given below:
        </p>

        {/* Group A Table */}
        <h4 style={heading}>Group A (Language Subjects)</h4>
        <div style={tableWrapper}>
          <table style={tableStyle}>
            <thead>
              <tr style={theadStyle}>
                <th style={thtd}>SR. NO.</th>
                <th style={thtd}>CODE</th>
                <th style={thtd}>SUBJECT</th>
              </tr>
            </thead>
            <tbody>
              {seniorGroupA.map((item, index) => (
                <tr
                  key={item.code}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f2f3f7" : "white",
                  }}
                >
                  <td style={thtd}>{item.sr}</td>
                  <td style={thtd}>{item.code}</td>
                  <td style={thtd}>{item.subject}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Group B Table */}
        <h4 style={heading}>Group B (Non-Language Subjects)</h4>
        <div style={tableWrapper}>
          <table style={tableStyle}>
            <thead>
              <tr style={theadStyle}>
                <th style={thtd}>SR. NO.</th>
                <th style={thtd}>CODE</th>
                <th style={thtd}>SUBJECT</th>
              </tr>
            </thead>
            <tbody>
              {seniorGroupB.map((item, index) => (
                <tr
                  key={item.code}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f2f3f7" : "white",
                  }}
                >
                  <td style={thtd}>{item.sr}</td>
                  <td style={thtd}>{item.code}</td>
                  <td style={thtd}>{item.subject}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p>
          Learners have to choose <strong>five subjects</strong> with at least
          one and maximum two Language Subjects from Group A and the remaining
          subjects from Group B.
        </p>

        <p>
          Two additional subjects can be taken from either of the two groups
          with additional fees as per BOSSE norms.
        </p>

        <p>Subjects with asterisk (*) have theory as well as practical.</p>
      </div>
    </>
  );
}
